import { render, staticRenderFns } from "./UpdateStock.vue?vue&type=template&id=951fa754"
import script from "./UpdateStock.vue?vue&type=script&lang=js"
export * from "./UpdateStock.vue?vue&type=script&lang=js"
import style0 from "./UpdateStock.vue?vue&type=style&index=0&id=951fa754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports